import Dossier from '@/dossier/models/Dossier';
import Memo from './Memo';
import Task from './Task';
import TaskContext from './TaskContext';

export class DossierTaskContext extends TaskContext {
  private active = true;

  constructor(
    readonly dossier: Dossier,
    tasks: Array<Task>,
    memos: Array<Memo>,
  ) {
    super();
    this.tasks = tasks;
    this.memos = memos;
  }

  free(): void {
    super.free();
    this.active = false;
  }
}